var Event;

(function (Event) {
  Event["mount"] = "event_mount";
  Event["tapCustom"] = "event_tap_custom";
  Event["tapClose"] = "event_tap_close";
  Event["tapConfirm"] = "event_tap_confirm";
  Event["addRelated"] = "event_add_related";
})(Event || (Event = {}));

var Event$1 = Event;

export default Event$1;
